import { action } from 'typesafe-actions';
import { continueActionTypes as act } from './continueActionTypes';

export function setAccount(type) {
  return action(act.ACCOUNT, type);
}
export function setAmount(type) {
  return action(act.AMOUNT, type);
}
export function setTransferType(type) {
  return action(act.TRANSFER, type);
}
export function setPartialTransfer(type) {
  return action(act.PARTIALTRANSFER, type);
}
